import React from "react";

import { Tooltippy } from "../../actions/Tippy";

import "./queue-tab.styles.css";

const QueueTab = ({
  tabInfo = {
    id: "nextCall",
    title: "Próx. Atend.",
    qtdClients: 99,
    isActive: true,
  },
  qtdClients = 0,
  qtdMessages = 0,
  onClick = () => {},
  iconUse = false,
}) => {
  const hasQtdMessages = !!qtdMessages;

  const renderContent = () => (
    <div
      className={`queue-tab__container ${
        qtdClients.length > 2 ? "less-size" : ""
      }`}
    >
      {iconUse ? tabInfo.icon : ""}
      <span className={`queue-tab__container__text`}>{`${
        iconUse ? "" : tabInfo.title
      } (${qtdClients})`}</span>
      {hasQtdMessages && (
        <span className="queue-tab__container__qtd-messages">
          {qtdMessages}
        </span>
      )}
    </div>
  );

  return (
    <div
      className={`queue-tab ${tabInfo.isActive ? "active" : ""} ${
        iconUse ? "icon-mode" : ""
      }`}
      onClick={onClick}
    >
      {iconUse ? (
        <Tooltippy content={tabInfo.title}>{renderContent()}</Tooltippy>
      ) : (
        renderContent()
      )}
    </div>
  );
};

export default QueueTab;
